import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    NameCorporateName: { label: i18n.t('app.name'), value: '' },
    TIN: { label: i18n.t('companies.cif'), value: '' },
    FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
    SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
    ResidenceType: { label: i18n.t('agenda.ResidenceTypeCode'), value: '' },
    PersonType: { label: i18n.t('agenda.PersonTypeCode'), value: '' },
    Locations: { label: i18n.t('sedes.header'), value: '' },
    LinkedCompanies: { label: i18n.t('companies.companies_link'), value: '' },
    Book: { label: i18n.t('contacto.Book'), value: '' },
    RegisterOfCompaniesLocation: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
    Sheet: { label: i18n.t('contacto.Sheet'), value: '' },
    Folio: { label: i18n.t('contacto.Folio'), value: '' },
    Section: { label: i18n.t('contacto.Section'), value: '' },
    Volume: { label: i18n.t('contacto.Volume'), value: '' },
    AdditionalData: { label: i18n.t('agenda.additional_data'), value: '' },
    CoverEquivalenceSurcharge: { label: i18n.t('impuestos.equivalence_surcharge'), value: '' },
    roleType: { label: i18n.tc('agenda.rol', 1), value: '' }
  } 
}
const getColumns = function getColumns () {
  return [
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      },
    },
    { field: 'NameCorporateName', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'TIN', title: i18n.t('companies.cif'), columnMenu: 'myTemplate', width: '225px', locked: false },
    { field: 'FirstSurname', title: i18n.t('persons_data.firstsurname'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'SecondSurname', title: i18n.t('persons_data.secondsurname'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ResidenceType', title: i18n.t('agenda.ResidenceTypeCode'), format: 'TIPOS_RESIDENCIA', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '400px', locked: false },
    { field: 'PersonType', title: i18n.t('agenda.PersonTypeCode'), format: 'TIPOS_PERSONA', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Locations', width: '440px', title: i18n.t('sedes.header'), columnMenu: 'myTemplate', locked: false, cell: 'tagsTemplate', type: 'boolean', sortable: false, groupable: false },
    { field: 'CoverEquivalenceSurcharge', width: '200px', title: i18n.t('impuestos.equivalence_surcharge'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'LinkedCompanies', width: '440px', title: i18n.t('companies.companies_link'), columnMenu: 'myTemplate', locked: false, cell: 'tagsTemplate', type: 'boolean', sortable: false, groupable: false },
    // { field: 'RegistrationData.Book', title: i18n.t('contacto.Book'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    // { field: 'RegistrationData.RegisterOfCompaniesLocation', title: i18n.t('contacto.RegisterOfCompaniesLocation'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    // { field: 'RegistrationData.Sheet', title: i18n.t('contacto.Sheet'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    // { field: 'RegistrationData.Folio', title: i18n.t('contacto.Folio'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    // { field: 'RegistrationData.Section', title: i18n.t('contacto.Section'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    // { field: 'RegistrationData.Volume', title: i18n.t('contacto.Volume'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    // { field: 'RegistrationData.AdditionalData', title: i18n.t('agenda.additional_data'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
    { field: 'IdSociedad', title: i18n.t('app.id'), columnMenu: 'myTemplate', width: '200px', locked: false, hidden: true },
  ]
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
}

const mystore = parent({ actions, selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
